export const FIELD_TYPES = {
    STRING: "String",
    BOOLEAN: "Boolean",
    CURRENCY: "Currency",
    ENUM: "Enum",
    MULTISELECTENUM: "MultiSelectEnum",
    LABEL: "Label",
    DATE: "Date",
    TEXTAREA: "Textarea",
    RADIO: "Radio",
    FREEHANDDRAW: "FreeHandDraw",
    BUTTON: "Button",
    ENUM_MODAL: "EnumModal",
    FILE_UPLOAD: "FileUpload",
}

export const HELPTEXT_TYPES = {
    TOOLTIP: 'tooltip',
    IFRAME: 'iframe',
    LINK: 'link',
}

export const VALIDATION_RULE = {
    REQUIRED: "Required",
    MAXXPERCENTOF: "MaxXPercentOf",  
    NUMERIC: "Numeric",  
    REGULAREXPRESSION: "RegularExpression",  
    STRINGLENGTH: "StringLength",
    SHOULDBELESSTHAN: "ShouldBeLessThan",
    VALUECOMPARE: "ValueCompare",
    NOTREQUIREDIFFIELDFILLED: "NotRequiredIfFieldFilled",
    REQUIREDIFFIELDFILLED: "RequiredIfFieldFilled",
    ATLEASTONEFIELDREQUIRED: "AtLeastOneFieldRequired",
    NOTREQUIREDIFMULTIFIELDFILLED: "NotRequiredIfMultiFieldFilled",
}

export const HANDLE_DEPENDENTFIELDS_CB_FOR_FIELD_TYPES = [FIELD_TYPES.BOOLEAN, FIELD_TYPES.RADIO, FIELD_TYPES.BUTTON];

export const IRS_DROPDOWN_SELECT_CB_FIELDS = {
    PAYERID: "PayerID",
    PAYEEID: "PayeeID",
    YEARID: "YearId",
};